module.exports = __webpack_public_path__ + "img/moneymatch.1ecbf3a7.png";